@if (canAcceptValidation && nextValidationType) {
  <button
    mat-icon-button
    [matMenuTriggerFor]="userMenu.menu"
    [matTooltip]="
      'Accepter et demander la validation ' + (nextValidationType | validationRequestTypeLabel)
    "
  >
    <mat-icon class="warning">playlist_add_check</mat-icon>
  </button>
  <app-user-menu
    #userMenu
    [roles]="requestToRoles"
    (userSelected)="acceptAndRequestValidation($event)"
  ></app-user-menu>
}
